import { twMerge } from "tailwind-merge";
import clsx from "clsx";

/**
 * @param {import("tailwind-merge").ClassNameValue} classNames
 * @returns {string}
 */
export const cn = (...classNames) => {
  return twMerge(clsx(classNames));
};

export const formatDate = (date, dateStyle) => {
  if (typeof date === "string") date = new Date(date);
  return Intl.DateTimeFormat("en-US", { dateStyle: dateStyle }).format(date);
};
